import React, { useEffect, useState } from "react";
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
  useParams,
  useLocation,
  useNavigate,
} from "react-router-dom";
import { API, graphqlOperation, Amplify, Auth } from "aws-amplify";
import { withAuthenticator } from "@aws-amplify/ui-react";
import "./App.css";
import "@aws-amplify/ui-react/styles.css";
import awsExports from "./aws-exports";
import { listCandidateProfiles } from "./graphql/queries";
import { RiseLoader } from "react-spinners";
import { CircularProgress, Typography } from '@mui/material';
import {
  listInterviewEvaluations
} from './graphql/queries';

// Import your components here

import InterviewSlotBook from "./pages/admin/InterviewSlotBook.js";

import CandidateProfileReg from "./pages/CandidateProfileReg";
import CandidateSchedule from "./pages/CandidateSchedule";
import CandidateResumeDetails from "./pages/CandidateResumeDetails.js";
import TermsPolicy from "./pages/TermsPolicy";
import CandidateProfile from "./pages/CandidateProfile.js";
import InterviewEvaluationViewer from "./components/InterviewEvaluationViewer.js";
import EditCandidateProfileReg from "./pages/EditCandidateProfileReg.js";
import AdminAddcontext from "./pages/AdminAddcontext.js";
import StudentDashbord from "./pages/StudentDashbord";
import WhoAreYou from "./pages/WhoAreYou";
import CompanyDashboard from "./pages/CompanyDashboard";
import CompanyPage from "./pages/CompanyPage.js";
import logo from "./assets/logogetscreened.svg";
import CandidateInterviewSlotList from "./pages/admin/CandidateInterviewSlotList.js";
import Header1 from "./components/Header1/Header1.js";
import CompanyCandidateViewProfilev1, { CompanyCandidateViewProfilev1Wrapper } from "./pages/Company/CompanyCandidateViewProfilev1.js";
import CompanyRegistarFrom from "./pages/Company/CompanyRegistarFrom.js";
import CompanyTerms from "./pages/Company/CompanyTerms.js";
import CompanyHome from "./pages/Company/CompanyHome.js";
import SendMail from "./pages/Company/SendMail.js";
import CompanyProfile from "./pages/Company/CompanyProfile.js";
import PrivateRoute from "./components/PrivateRoute/PrivateRoute.js";
import { listCompanyProfiles } from "./graphql/queries";
import CompanyJdform from "./components/company/CompanyJdform.js";
import BuyPremium from "./components/company/BuyPremium.js";
import PaymentComponent from "./components/company/PaymentComponent.js";
import Compensationbenefits from "./pages/Compensationbenefits.js";
import JobDetailsList from "./pages/Company/JobDetailsList .js";
import JobPostDetails from "./pages/Company/JobPostDetails.js";
import JobDetails from "./components/company/JobDetails.js";
import AdminCandidateViewProfile from "./pages/admin/AdminCandidateViewProfile.js";
import Showmyskill from "./pages/Showmyskill.js";
import ShowMySkills from "./pages/share/ShowMySkills.js";
import ProfilePage from "./pages/ProfilePage.js";
import AdminPrivateRoute from "./pages/admin/AdminPrivateRoute.js";
import CompanyPrivateRoute from "./pages/Company/CompanyPrivateRoute.js";
import CompanyGlobal from "./pages/Company/CompanyGlobal.js";
import UpdateCandidate from "./pages/admin/UpdateCandidate.js";
import Spot from "./pages/Company/Spot.js";
import SpotSearch from "./pages/Company/SpotSearch.js";
import SpotGPT from "./pages/Company/SpotGPT.js";
import SpotPlus from "./pages/Company/SpotPlus.js";
import SpotPlusAskAi from "./pages/Company/SpotPlusAskAi.js";
import SpotPlusCandidte from "./pages/Company/SpotPlusCandidte.js";
import SpotPlusForm from "./pages/Company/SpotPlusForm.js";
import SpotPlusJd from "./pages/Company/SpotPlusJd.js";
import SpotPlusCard from "./pages/Company/SpotPlusCard.js";
import SpotPlusSendMailPopup from "./pages/Company/SpotPlusSendMailPopup.js";
import SpotPlusCampain from "./pages/Company/SpotPlusCampain.js";
import SpotPlusStudentDetails from "./pages/Company/SpotPlusStudentDetails.js";
import SpotPlusProfile from "./pages/Company/SpotPlusProfile.js";
import SpotPlusSearch from "./pages/Company/SpotPlusSearch.js";
import SpotPlusScoreCard from "./pages/Company/SpotPlusScoreCard.js";
import SpotPlusSelectedCard from "./pages/Company/SpotPlusSelectedCard.js";
import SpotPlusYourJd from "./pages/Company/SpotPlusYourJd.js";
import { SpotProvider } from "./context/SpotContext.js";
import SpotComingSoon from "./pages/Company/SpotComingSoon.js";
import Interview from "./pages/Interview.js";
import InterviewRefactored from "./pages/InterviewRefactored.js";
import PublicInterview from "./pages/PublicInterview";
import EnhancedInterviewResults from "./pages/EnhancedInterviewResults";
import DemoInterviewLanding from "./pages/DemoInterviewLanding";
import CandidateInterviewSelector from "./pages/CandidateInterviewSelector";
import StudyDashboard from "./pages/StudyDashboard";

Amplify.configure(awsExports);

const HeaderWithLogo = () => {
  return (
    <div
      style={{ display: "flex", flexDirection: "column", alignItems: "center" }}
    >
      <img src={logo} alt="Logo" style={{ width: "450px" }} />
      {/* <h3 style={{ textAlign: "center" }}>Welcome to GetScreened App</h3> */}
      {/* <p style={{ textAlign: "center" }}>Powered by Varahi Technologies</p> */}
    </div>
  );
};

function Footer() {
  return (
    <div
      style={{ textAlign: "center", marginTop: "20px", marginBottom: "10px" }}
    >
      <p>Powered by Varahi Technologies</p>
    </div>
  );
}
function App() {
  const [userProfileExists, setUserProfileExists] = useState(null);
  const [companyUserExists, setCompanyUserExists] = useState(null);
  //private route code start here

  const [email, setEmail] = useState("");
  const [companyList, setCompanyList] = useState([]);
  const [nextToken, setNextToken] = useState(null);
  const [loading, setLoading] = useState(true);
  const [companyLoading, setCompanyLoading] = useState(true);
  const [company, setCompany] = useState(null);

  //private route code end here

  // Force clear all localStorage data
  function forceClearLocalStorage() {
    // Method 1: Remove specific items multiple times to ensure they're gone
    const keysToRemove = [
      'candidateProfile',
      'candidateProfileAuthID', 
      'candidateProfileEmailID',
      'candidateProfileId',
      'lastSessionId',
      'lastTokenId',
      'sessionGraceTime'
    ];
    
    // Clear specific items 3 times to ensure removal
    for (let i = 0; i < 3; i++) {
      keysToRemove.forEach(key => {
        localStorage.removeItem(key);
      });
    }
    
    // Method 2: Clear everything multiple times
    localStorage.clear();
    sessionStorage.clear();
    localStorage.clear(); // Clear again to be sure
    
    // Method 3: Force remove by getting all keys and removing them
    const allKeys = Object.keys(localStorage);
    allKeys.forEach(key => {
      localStorage.removeItem(key);
    });
    
    // Final clear
    localStorage.clear();
  }

  // Test function to manually clear localStorage (for debugging)
  window.testClearLocalStorage = function() {
    forceClearLocalStorage();
  };

  // Test function to simulate authentication failure
  window.simulateAuthFailure = function() {
    forceClearLocalStorage();
    forceCompleteLogout();
  };

  // Comprehensive session validation and security functions
  async function forceCompleteLogout() {
    try {
      // Clear all localStorage data
      localStorage.clear();

      // Clear all sessionStorage data
      sessionStorage.clear();

      // Clear IndexedDB cache if available
      if (window.indexedDB) {
        const databases = ['amplify-datastore', 'aws-amplify-cache', 'aws-amplify'];
        databases.forEach(async (dbName) => {
          try {
            const deleteReq = indexedDB.deleteDatabase(dbName);
            deleteReq.onsuccess = () => {};
            deleteReq.onerror = () => {};
          } catch (e) {}
        });
      }

      // Force global sign out from all devices/browsers
      try {
        await Auth.signOut({ global: true });

      } catch (signOutError) {}

      // Redirect to clean sign-in page without parameters
      window.location.href = '/';

    } catch (error) {
      // Even if everything fails, still redirect to clean sign-in page
      window.location.href = '/';
    }
  }

  // Validate user session and detect suspended/disabled accounts
  async function validateUserSession() {
    try {
      // Step 1: Check if session exists and is valid
      const session = await Auth.currentSession();

      if (!session || !session.isValid()) {
        throw new Error('Session invalid or expired');
      }

      // Step 2: Get fresh user info with cache bypass to detect changes
      const userInfo = await Auth.currentAuthenticatedUser({ bypassCache: true });

      // Step 3: Enhanced session tracking for admin action detection
      const currentTokenId = session.getIdToken().payload.jti; // JWT ID for uniqueness
      const currentSessionId = session.getIdToken().payload.iat; // Session timestamp
      const storedTokenId = localStorage.getItem('lastTokenId');
      const storedSessionId = localStorage.getItem('lastSessionId');
      const sessionGraceTime = localStorage.getItem('sessionGraceTime');
      const currentTime = Date.now();

      // Check for AWS admin actions or password reset
      if (storedTokenId && storedSessionId) {
        const tokenChanged = storedTokenId !== currentTokenId;
        const sessionChanged = storedSessionId !== currentSessionId.toString();
        const sessionTimeDiff = Math.abs(parseInt(storedSessionId) - currentSessionId);
        const isGracePeriodOver = !sessionGraceTime || (currentTime - parseInt(sessionGraceTime)) > 1800000; // Extended to 30 minutes

        // Detect significant changes after grace period = admin action or password reset
        if (isGracePeriodOver && (tokenChanged || sessionChanged)) {
          throw new Error('Session invalidated - admin action or forgot password detected');
        }

        // During grace period, detect major changes (>10 minutes difference) = forgot password
        if (!isGracePeriodOver && sessionTimeDiff > 600) {
          throw new Error('Forgot password detected - session invalidated');
        }
      }

      // Store current session info and set grace time for new sessions
      if (!storedTokenId || !storedSessionId ||
        storedTokenId !== currentTokenId || storedSessionId !== currentSessionId.toString()) {
        localStorage.setItem('lastTokenId', currentTokenId);
        localStorage.setItem('lastSessionId', currentSessionId.toString());
        localStorage.setItem('sessionGraceTime', currentTime.toString());
      }

      return { isValid: true, userInfo };

    } catch (error) {
      // Handle AWS admin actions (suspend, disable, force signout)
      if (error.code === 'NotAuthorizedException' &&
        (error.message?.includes('User is disabled') ||
          error.message?.includes('User account is disabled') ||
          error.message?.includes('Access Token has been revoked'))) {
        await forceCompleteLogout();
        return { isValid: false };
      }

      // Handle token expiration and invalid tokens
      if (error.code === 'TokenExpiredException' ||
        error.code === 'UserNotFoundException' ||
        error.message?.includes('Invalid token') ||
        error.message?.includes('Token is not valid')) {
        await forceCompleteLogout();
        return { isValid: false };
      }

      // Handle confirmed admin actions or password resets
      if (error.message?.includes('Session invalidated') ||
        error.message?.includes('admin action') ||
        error.message?.includes('password reset')) {
        await forceCompleteLogout();
        return { isValid: false };
      }

      // For other errors, just log and continue (don't force logout)
      return { isValid: false, error: error };
    }
  }

  // Real-time session monitoring for AWS admin actions
  async function monitorSession() {
    try {
      // Force fresh validation against AWS Cognito
      const session = await Auth.currentSession();
      const userInfo = await Auth.currentAuthenticatedUser({ bypassCache: true });

      // Check user attributes to detect suspension/disable
      try {
        const userAttributes = await Auth.userAttributes(userInfo);
      } catch (attrError) {
        if (attrError.code === 'NotAuthorizedException' ||
          attrError.message?.includes('User is disabled')) {
          await forceCompleteLogout();
          return false;
        }
      }

      // Check for session changes
      const currentTokenId = session.getIdToken().payload.jti;
      const currentSessionId = session.getIdToken().payload.iat;
      const storedTokenId = localStorage.getItem('lastTokenId');
      const storedSessionId = localStorage.getItem('lastSessionId');
      const sessionGraceTime = localStorage.getItem('sessionGraceTime');
      const isGracePeriodOver = !sessionGraceTime || (Date.now() - parseInt(sessionGraceTime)) > 1800000; // Extended to 30 minutes

      // Detect AWS admin actions after grace period
      if (storedTokenId && storedSessionId && isGracePeriodOver) {
        const tokenChanged = storedTokenId !== currentTokenId;
        const sessionChanged = storedSessionId !== currentSessionId.toString();

        if (tokenChanged || sessionChanged) {
          await forceCompleteLogout();
          return false;
        }
      }

      const sessionCheck = await validateUserSession();
      return sessionCheck.isValid;

    } catch (error) {
      // AWS admin action indicators
      if (error.code === 'NotAuthorizedException' ||
        error.code === 'UserNotFoundException' ||
        error.message?.includes('Access Token has been revoked') ||
        error.message?.includes('Invalid Access Token') ||
        error.message?.includes('Token is not valid') ||
        error.message?.includes('User is disabled')) {
        await forceCompleteLogout();
        return false;
      }

      return true; // Continue monitoring on other errors
    }
  }

  useEffect(() => {
    // Check if this is a public route
    const currentPath = window.location.pathname;
    const isPublic = currentPath.startsWith('/public-interview/') || currentPath.startsWith('/public-profile') || currentPath.startsWith('/demo-interview');
    
    // Only check user profile if not a public route
    if (!isPublic) {
      checkUserProfile();
    } else {
      // For public routes, skip authentication checks completely
      setLoading(false);
    }
  }, []);

  // Real-time session monitoring useEffect - AWS Admin Actions & Forgot Password Detection
  useEffect(() => {
    let sessionMonitorInterval;
    let adminActionMonitorInterval;

    const startSessionMonitoring = () => {
      // AWS Admin Action & Forgot Password Detection (Balanced)
      adminActionMonitorInterval = setInterval(async () => {
        try {
          // Force fresh token validation to detect AWS admin actions immediately
          const freshSession = await Auth.currentSession();
          const freshUser = await Auth.currentAuthenticatedUser({ bypassCache: true });

          // Check user attributes to detect suspension/disable
          try {
            const userAttributes = await Auth.userAttributes(freshUser);
          } catch (attrError) {
            if (attrError.code === 'NotAuthorizedException' ||
              attrError.message?.includes('User is disabled')) {
              
              // Clear all localStorage immediately when authentication fails
              forceClearLocalStorage();
              
              await forceCompleteLogout();
              clearInterval(sessionMonitorInterval);
              clearInterval(adminActionMonitorInterval);
              return;
            }
          }

          const currentTokenId = freshSession.getIdToken().payload.jti;
          const currentSessionId = freshSession.getIdToken().payload.iat;
          const storedTokenId = localStorage.getItem('lastTokenId');
          const storedSessionId = localStorage.getItem('lastSessionId');
          const sessionGraceTime = localStorage.getItem('sessionGraceTime');
          const currentTime = Date.now();

          // Smart detection for AWS admin actions and forgot password
          const isWithinGracePeriod = sessionGraceTime && (currentTime - parseInt(sessionGraceTime)) < 1800000; // Extended to 30 minutes grace
          const hasStoredValues = storedTokenId && storedSessionId;

          if (hasStoredValues) {
            const tokenChanged = storedTokenId !== currentTokenId;
            const sessionChanged = storedSessionId !== currentSessionId.toString();
            const sessionTimeDiff = Math.abs(parseInt(storedSessionId) - currentSessionId);

            // After grace period: Any token change = admin action or forgot password
            if (!isWithinGracePeriod && (tokenChanged || sessionChanged)) {
              
              // Clear all localStorage immediately when admin action detected
              forceClearLocalStorage();
              
              await forceCompleteLogout();
              clearInterval(sessionMonitorInterval);
              clearInterval(adminActionMonitorInterval);
              return;
            }

            // During grace period: Only major changes (>10 minutes) = admin action or forgot password
            if (isWithinGracePeriod && sessionTimeDiff > 600) {
              
              // Clear all localStorage immediately when major admin action detected
              forceClearLocalStorage();
              
              await forceCompleteLogout();
              clearInterval(sessionMonitorInterval);
              clearInterval(adminActionMonitorInterval);
              return;
            }
          }

          // Update stored values for tracking
          if (!hasStoredValues || !isWithinGracePeriod) {
            localStorage.setItem('lastTokenId', currentTokenId);
            localStorage.setItem('lastSessionId', currentSessionId.toString());
          }

        } catch (error) {
          // IMMEDIATE localStorage clearing on ANY authentication error
          forceClearLocalStorage();

          // These errors indicate AWS admin actions (suspend, disable, force signout, forgot password)
          if (error.code === 'NotAuthorizedException' ||
            error.code === 'UserNotFoundException' ||
            error.code === 'TokenExpiredException' ||
            error.message?.includes('Access Token has been revoked') ||
            error.message?.includes('Invalid Access Token') ||
            error.message?.includes('Token is not valid') ||
            error.message?.includes('User is disabled') ||
            error.message?.includes('User account has been disabled') ||
            error.message?.includes('Refresh Token has been revoked')) {
            
            await forceCompleteLogout();
            clearInterval(sessionMonitorInterval);
            clearInterval(adminActionMonitorInterval);
          } else {
            // Even for other errors, clear localStorage and stop monitoring
            clearInterval(sessionMonitorInterval);
            clearInterval(adminActionMonitorInterval);
          }
        }
      }, 60000); // Check every 1 minute

      // Regular session monitoring (less frequent, for general health)
      sessionMonitorInterval = setInterval(async () => {
        try {
          const isSessionValid = await monitorSession();
          if (!isSessionValid) {
            
            // Clear all specific localStorage items when session becomes invalid
            localStorage.removeItem('candidateProfile');
            localStorage.removeItem('candidateProfileAuthID');
            localStorage.removeItem('candidateProfileEmailID');
            localStorage.removeItem('candidateProfileId');
            localStorage.removeItem('lastSessionId');
            localStorage.removeItem('lastTokenId');
            localStorage.removeItem('sessionGraceTime');
            
            clearInterval(sessionMonitorInterval);
            clearInterval(adminActionMonitorInterval);
          }
        } catch (error) {
          
          // Clear localStorage on any monitoring error
          localStorage.removeItem('candidateProfile');
          localStorage.removeItem('candidateProfileAuthID');
          localStorage.removeItem('candidateProfileEmailID');
          localStorage.removeItem('candidateProfileId');
          localStorage.removeItem('lastSessionId');
          localStorage.removeItem('lastTokenId');
          localStorage.removeItem('sessionGraceTime');
          
          clearInterval(sessionMonitorInterval);
          clearInterval(adminActionMonitorInterval);
        }
      }, 300000); // Check every 5 minutes for general session health
    };

    // Start monitoring after initial load (10 seconds delay)
    const timer = setTimeout(startSessionMonitoring, 10000);

    return () => {
      clearTimeout(timer);
      if (sessionMonitorInterval) {
        clearInterval(sessionMonitorInterval);
      }
      if (adminActionMonitorInterval) {
        clearInterval(adminActionMonitorInterval);
      }
    };
  }, [userProfileExists]);

  // Tab visibility monitoring - immediate detection of AWS admin actions
  useEffect(() => {
    const handleVisibilityChange = async () => {
      if (!document.hidden && userProfileExists) {
        try {
          // Force check for AWS admin actions when tab becomes visible
          const freshSession = await Auth.currentSession();
          const freshUser = await Auth.currentAuthenticatedUser({ bypassCache: true });

          const currentTokenId = freshSession.getIdToken().payload.jti;
          const currentSessionId = freshSession.getIdToken().payload.iat;
          const storedTokenId = localStorage.getItem('lastTokenId');
          const storedSessionId = localStorage.getItem('lastSessionId');
          const sessionGraceTime = localStorage.getItem('sessionGraceTime');
          const currentTime = Date.now();

          // Smart detection on tab focus
          const isWithinGracePeriod = sessionGraceTime && (currentTime - parseInt(sessionGraceTime)) < 1800000; // Extended to 30 minutes
          const hasStoredValues = storedTokenId && storedSessionId;

          if (hasStoredValues) {
            const tokenChanged = storedTokenId !== currentTokenId;
            const sessionChanged = storedSessionId !== currentSessionId.toString();
            const sessionTimeDiff = Math.abs(parseInt(storedSessionId) - currentSessionId);

            // After grace period, check for admin actions
            if (!isWithinGracePeriod && (tokenChanged || sessionChanged)) {
              await forceCompleteLogout();
              return;
            }

            // During grace period, only check for major changes (>10 minutes)
            if (isWithinGracePeriod && sessionTimeDiff > 600) {
              await forceCompleteLogout();
              return;
            }
          }

          const isSessionValid = await monitorSession();
          if (!isSessionValid) {}
        } catch (error) {
          // AWS admin action errors
          if (error.code === 'NotAuthorizedException' &&
            (error.message?.includes('Access Token has been revoked') ||
              error.message?.includes('Invalid Access Token') ||
              error.message?.includes('Token is not valid') ||
              error.message?.includes('User is disabled'))) {
            await forceCompleteLogout();
          }
        }
      }
    };

    const handleWindowFocus = async () => {
      if (userProfileExists) {
        await handleVisibilityChange();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    window.addEventListener('focus', handleWindowFocus);

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleWindowFocus);
    };
  }, [userProfileExists]);

  const override = {
    display: "block",
    margin: "0 auto",
    borderColor: "red",
  };
  //Private route code start here

  useEffect(() => {
    // Skip company profile check for public routes
    const companyCheckPath = window.location.pathname;
    if (companyCheckPath.startsWith('/public-interview/') || companyCheckPath.startsWith('/public-profile') || companyCheckPath.startsWith('/demo-interview')) {
      setCompanyLoading(false);
      return;
    }
    
    // Wait for user profile check to complete (which sets the email in localStorage)
    // userProfileExists will be true/false after check, null during loading
    if (userProfileExists === null) {
      return; // Still waiting for user profile check to complete
    }
    
    const fetchData = async () => {
      try {
        const candidateProfileEmailID = localStorage.getItem(
          "candidateProfileEmailID"
        );
        setEmail(candidateProfileEmailID);
        // console.log("Email id", candidateProfileEmailID);

        if (!candidateProfileEmailID) {
          setCompanyLoading(false);
          // Handle case where candidate email is not found
          return;
        }

        const { data } = await API.graphql(
          graphqlOperation(listCompanyProfiles, {
            filter: {
              email: { eq: candidateProfileEmailID },
            },
            limit: 100, // Limit the number of items per page, adjust as needed
            nextToken: nextToken, // Pass nextToken if available
          })
        );
        // console.log("compay data from app", data);
        setCompany(data.listCompanyProfiles.items[0]);
        setCompanyUserExists(true);
        setCompanyLoading(false);

        if (data && data.listCompanyProfiles.items) {
          const { items, nextToken } = data.listCompanyProfiles;
          setCompanyList((prevList) => [...prevList, ...items]); // Merge new items with existing list
          setNextToken(nextToken); // Set the nextToken for pagination
          setLoading(false); // Set loading to false after data is fetched
        }
      } catch (error) {
        console.error("Error fetching data:", error);
        setCompanyUserExists(false);
        setCompanyLoading(false);
        // Handle error
      }
    };

    // Fetch immediately instead of waiting 2 seconds - email is now available
    fetchData();
  }, [userProfileExists, nextToken]); // Fetch when userProfileExists changes or nextToken changes

  //private code

  async function checkUserProfile() {
    try {
      // FIRST: Validate session comprehensively including AWS admin actions
      const sessionCheck = await validateUserSession();
      if (!sessionCheck.isValid && !sessionCheck.error) {
        setLoading(false);
        return; // User will be redirected by validateUserSession
      }

      // If there's an error but user might still be valid, continue with profile check
      let userInfo;
      if (sessionCheck.isValid) {
        userInfo = sessionCheck.userInfo;
      } else {
        // Try to get user info directly if session validation had errors
        try {
          userInfo = await Auth.currentAuthenticatedUser({ bypassCache: false });
        } catch (authError) {
          setLoading(false);
          return;
        }
      }

      const userId = userInfo.attributes.sub;
      const userEmail = userInfo.attributes.email.toLowerCase();

      localStorage.setItem("candidateProfileEmailID", userEmail);
      localStorage.setItem("candidateProfileAuthID", userId);

      let nextToken = null;
      let userProfile = null;

      do {
        const userProfileData = await API.graphql(
          graphqlOperation(listCandidateProfiles, {
            filter: {
              email: {
                eq: userEmail,
              },
            },
            limit: 100, // Adjust the limit as per your requirement
            nextToken: nextToken,
          })
        );

        const items = userProfileData.data.listCandidateProfiles.items;
        if (items.length > 0) {
          userProfile = items[0];
          localStorage.setItem("candidateProfileId", userProfile.id);
          localStorage.setItem("candidateProfile", JSON.stringify(userProfile));
          setUserProfileExists(true);
          break; // Exit the loop since a profile is found
        } else {
          // Continue to next iteration if there are more records to fetch
          nextToken = userProfileData.data.listCandidateProfiles.nextToken;
        }
      } while (nextToken);

      // If no profile found after exhausting all pages
      if (!userProfile) {
        setUserProfileExists(false);
      }

      setLoading(false);

    } catch (error) {
      console.error("Error fetching user profile", error);
      // Check if this is because there's no authenticated user (public route)
      const currentPath = window.location.pathname;
      if (currentPath.startsWith('/public-interview/') || currentPath.startsWith('/public-profile') || currentPath.startsWith('/demo-interview')) {
        // For public routes, this is expected - don't set profile as false
        setUserProfileExists(null); // Keep as null for public routes
        setLoading(false);
        return;
      }
      setUserProfileExists(false);
    }  
  }
  // console.log("11111111111111111111111111111111111111", userProfileExists);
  // console.log("222222222222222222222222222222222222", companyUserExists);
  // Show loading when user profile OR company profile is still being checked
  // This prevents the WhoAreYou page from flashing briefly during initial load
  const isStillLoading = (userProfileExists === null && loading) || companyLoading;
  
  if (isStillLoading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <RiseLoader
          color={"#ffffff"}
          loading={true}
          css={override}
          size={40}
          aria-label="Loading Spinner"
        />
      </div>
    );
  } else {
    return (
      <BrowserRouter
        future={{
          v7_startTransition: true,
          v7_relativeSplatPath: true
        }}
      >
        <Routes>
          <Route
            path="/"
            element={
              // userProfileExists ? <CandidateDashboard /> : <WhoAreYou />
              // userProfileExists ? <SendMail /> : <WhoAreYou />
              // userProfileExists && companyUserExists ? <PrivateRoute/> : <WhoAreYou />
              company || userProfileExists ? <PrivateRoute /> : <WhoAreYou />
              // userProfileExists ? <WhoAreYou /> : <TermsPolicy />
              // userProfileExists ? <CandidateResumeDetails  /> : <TermsPolicy />
            }
          />
          <Route
            path="/CandidateProfileReg"
            element={<CandidateProfileReg />}
          />
          <Route path="/TermsPolicy" element={<TermsPolicy />} />

          <Route path="/CompanyPage" element={<CompanyPage />} />
          <Route 
            path="/CandidateSchedule" 
            element={
              <ProtectedCandidateRoute>
                <CandidateSchedule />
              </ProtectedCandidateRoute>
            } 
          />
          <Route path="/CandidateProfile" element={<CandidateProfile />} />
          <Route path="/StudentDashboard" element={<StudentDashbord />} />

          {/* <Route path="/InterviewSlotBook" element={<InterviewSlotBook />} /> */}

          <Route path="/PaymentComponent" element={<PaymentComponent />} />
          <Route path="/CompanyJdform" element={<CompanyJdform />} />

          <Route path="/JobPostDetails" element={<JobPostDetails />} />

          <Route path="/CompanyProfile" element={<CompanyProfile />} />
          <Route path="/Showmyskill" element={<Showmyskill />} />
          <Route path="/ShowMySkills" element={<ShowMySkills />} />          
          <Route path="/ProfilePage" element={<ProfilePage />} />
          <Route path="/interview/:id" element={<InterviewRefactored/>} />
          <Route path="/interview-evaluations" element={<InterviewEvaluationViewer />} />
          <Route path="/public-interview/:accessToken" element={<PublicInterview />} />
          <Route path="/public-profile" element={<PublicProfileWrapper />} />
          <Route path="/demo-interview" element={<DemoInterviewLanding />} />
          <Route path="/candidate-interview-selector" element={<CandidateInterviewSelector />} />
          <Route path="/study-dashboard" element={<StudyDashboard />} />
          

          {/* Admin Private Route start */}

          <Route element={<AdminPrivateRoute />}>
            <Route path="/AdminAddcontext" element={<AdminAddcontext />} />
            <Route path="/InterviewSlotBook" element={<InterviewSlotBook />} />
            <Route
              path="/CandidateInterviewSlotList"
              element={<CandidateInterviewSlotList />}
            />
            <Route path="/CompanyDashboard" element={<CompanyDashboard />} />
            <Route
              path="/AdminCandidateViewProfile"
              element={<AdminCandidateViewProfile />}
            />
            <Route path="/UpdateCandidate" element={<UpdateCandidate />} />
          </Route>

          {/* Admin Private Route end */}

          {/* Company Private Route start */}

          <Route element={<CompanyPrivateRoute />}>
            <Route path="/JobDetailsList" element={<JobDetailsList />} />
            <Route path="/JobDetails" element={<JobDetails />} />
            <Route path="/SendMail" element={<SendMail />} />
            <Route path="/Spot" element={<Spot />} />
            <Route path="/SpotSearch" element={<SpotSearch />} />
            <Route path="/SpotGPT" element={<SpotGPT />} />

            <Route path="/SpotPlus" element={<SpotPlus />} />

            {/* testing code start */}

            <Route
              path="/SpotPlusAskAi"
              element={
                <SpotProvider>
                  <SpotPlusAskAi />
                </SpotProvider>
              }
            />

            <Route
              path="/SpotPlusCandidte"
              element={
                <SpotProvider>
                  <SpotPlusCandidte />
                </SpotProvider>
              }
            />

            {/* testing code end */}

            <Route path="/SpotPlusForm" element={<SpotPlusForm />} />
            <Route path="/SpotPlusJd" element={<SpotPlusJd />} />
            <Route path="/SpotPlusCard" element={<SpotPlusCard />} />
            <Route path="/SpotPlusProfile" element={<SpotPlusProfile />} />
            <Route path="/SpotPlusSearch" element={<SpotPlusSearch />} />
            <Route path="/SpotPlusYourJd" element={<SpotPlusYourJd />} />
            <Route
              path="/SpotPlusSendMailPopup"
              element={<SpotPlusSendMailPopup />}
            />
            <Route path="/SpotPlusCampain" element={<SpotPlusCampain />} />
            <Route
              path="/SpotPlusStudentDetails"
              element={<SpotPlusStudentDetails />}
            />
            <Route path="/SpotComingSoon" element={<SpotComingSoon />} />

          </Route>
          {/* Company Private Route end */}

          <Route
            path="/CompanyCandidateViewProfilev1/:email"
            element={<CompanyCandidateViewProfileWrapperv1 />}
          />


          <Route path="/CompanyGlobal" element={<CompanyGlobal />} />

          <Route
            path="/Compensationbenefits"
            element={<Compensationbenefits />}
          />
          {/* commented for im not getting props alter net got below from ooriginal  */}
          {/* <Route path="/CompanyCandidateViewProfile" element={<CompanyCandidateViewProfile />} /> */}

          <Route
            path="/CompanyRegisterForm"
            element={<CompanyRegistarFrom />}
          />
          <Route path="/CompanyTerms" element={<CompanyTerms />} />
          <Route path="/CompanyHome" element={<CompanyHome />} />
          <Route path="/PrivateRoute" element={<PrivateRoute />} />
          <Route path="/BuyPremium" element={<BuyPremium />} />

          {/* <Route path="/Header" element={<Header1 />} /> */}

          <Route
            path="/CandidateResumeDetails"
            element={<CandidateResumeDetails />}
          />
          <Route
            path="/EditCandidateProfileReg"
            element={<EditCandidateProfileReg />}
          />
          <Route path="/SpotPlusScoreCard" element={<SpotPlusScoreCard />} />
          <Route
            path="/SpotPlusSelectedCard"
            element={<SpotPlusSelectedCard />}
          />

          {/* Redirect all other paths to dashboard or terms based on the profile existence */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
    );
  }
}

// Protected Route for Candidate Pages
const ProtectedCandidateRoute = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const navigate = useNavigate();

  React.useEffect(() => {
    const checkAuth = async () => {
      try {
        await Auth.currentAuthenticatedUser();
        const email = localStorage.getItem("candidateProfileEmailID");
        
        // Check if user is a candidate (not admin or company)
        if (email && 
            email !== "getscreened@varahitechnologies.com" && 
            email !== "hr@varahitechnologies.com") {
          setIsAuthenticated(true);
        } else {
          setIsAuthenticated(false);
          navigate("/");
        }
      } catch (error) {
        console.log("Not authenticated:", error);
        setIsAuthenticated(false);
        navigate("/");
      } finally {
        setIsLoading(false);
      }
    };

    checkAuth();
  }, [navigate]);

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-screen bg-slate-900">
        <RiseLoader color={"#3b82f6"} loading={true} size={15} />
      </div>
    );
  }

  return isAuthenticated ? children : null;
};

// const CompanyCandidateViewProfileWrapper = () => {
//   const { email } = useParams();
//   const location = useLocation();
//   return <CompanyCandidateViewProfile email={email} {...location.state} />;
// };

const CompanyCandidateViewProfileWrapperv1 = () => {
  const { email } = useParams();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const slotId = searchParams.get('slotId') || searchParams.get('slot-id'); // Support both formats

  try {
    return (
      <CompanyCandidateViewProfilev1Wrapper
        emailProp={email}
        slotIdProp={slotId}
        skipFetch={false}
      />
    );
  } catch (error) {
    console.error("Error in CompanyCandidateViewProfileWrapperv1:", error);
    return <div>Error loading component: {error.message}</div>;
  }
};

// Public Profile Wrapper for iframe embedding and public access with expiration
// Simplified version without JWT service dependencies
const PublicProfileWrapper = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const encodedEmail = searchParams.get('e') || searchParams.get('email');
  const slotId = searchParams.get('slot') || searchParams.get('slot-id');
  const timestamp = searchParams.get('t');

  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [expired, setExpired] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);

  useEffect(() => {
    let mounted = true;

    const tryDecodeEmail = (enc) => {
      if (!enc) return null;
      try {
        if (/^[A-Za-z0-9+/]*={0,2}$/.test(enc)) {
          return atob(enc);
        }
        return enc;
      } catch (e) {
        return enc;
      }
    };

    const handlePublicFlow = () => {
      const decoded = tryDecodeEmail(encodedEmail);
      if (mounted) {
        setEmail(decoded);
      }

      // Default validity for legacy `t` timestamp is 5 minutes (300000 ms)
      const VALIDITY_MS = 5 * 60 * 1000;
      if (!timestamp) {
        // No timestamp provided — treat as invalid unless admin
        if (!decoded) {
          setErrorMsg('Missing timestamp');
          setLoading(false);
          return;
        }
      }

      if (timestamp) {
        const t = parseInt(timestamp, 10);
        const expiryMs = t + VALIDITY_MS;
        if (Date.now() > expiryMs) {
          setExpired(true);
          setLoading(false);
          return;
        }
      }

      setLoading(false);
    };

    handlePublicFlow();

    return () => {
      mounted = false;
    };
  }, [location.search, encodedEmail, timestamp]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <RiseLoader color={"#ffffff"} loading={true} css={{ display: 'block', margin: '0 auto' }} size={40} />
      </div>
    );
  }

  if (expired) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh', 
        fontFamily: 'Arial, sans-serif', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white', 
        textAlign: 'center' 
      }}>
        <div style={{
          background: 'rgba(255, 255, 255, 0.1)',
          backdropFilter: 'blur(10px)',
          borderRadius: '20px',
          padding: '40px',
          border: '1px solid rgba(255, 255, 255, 0.2)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)'
        }}>
          <h2 style={{ marginBottom: '20px', fontSize: '2rem' }}>⏰ Session Expired</h2>
          <p style={{ marginBottom: '15px', fontSize: '1.1rem' }}>Your profile link has expired for security reasons.</p>
          <p style={{ marginBottom: '15px', opacity: 0.8 }}>Profile links are valid for 5 minutes by default.</p>
        </div>
      </div>
    );
  }

  if (errorMsg) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#666' }}>
        <div>
          <h2>Invalid Profile Link</h2>
          <p>{errorMsg}</p>
          <p>Please contact the administrator for a valid profile link.</p>
        </div>
      </div>
    );
  }

  if (!email) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#666' }}>
        <div>
          <h2>Invalid Profile Link</h2>
          <p>The profile link appears to be missing an email.</p>
          <p>Please contact the administrator for a valid profile link.</p>
        </div>
      </div>
    );
  }

  try {
    return (
      <CompanyCandidateViewProfilev1Wrapper
        emailProp={email}
        slotIdProp={slotId}
        skipFetch={false}
        isPublicAccess={true}
        isAdminAccess={false}
      />
    );
  } catch (error) {
    console.error("Error in PublicProfileWrapper:", error);
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'Arial, sans-serif', color: '#ff6b6b' }}>
        <div>
          <h2>Error Loading Profile</h2>
          <p>There was an error loading the candidate profile.</p>
          <p>Error: {error.message}</p>
        </div>
      </div>
    );
  }
};

// Create a wrapper component to handle authentication selectively
const AppWrapper = () => {
  // SYNCHRONOUS route check on initial render to prevent login flash
  const getIsPublicRoute = () => {
    const currentPath = window.location.pathname;
    return (
      currentPath.startsWith('/public-interview/') || 
      currentPath.startsWith('/public-profile') ||
      currentPath.startsWith('/demo-interview')
    );
  };
  
  const [isPublicRoute, setIsPublicRoute] = useState(getIsPublicRoute);
  const [isCheckingAuth, setIsCheckingAuth] = useState(!getIsPublicRoute());
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  
  // Check authentication status before rendering anything
  useEffect(() => {
    if (isPublicRoute) {
      setIsCheckingAuth(false);
      return;
    }
    
    const checkAuthStatus = async () => {
      try {
        // Check if user has valid Cognito session
        await Auth.currentAuthenticatedUser({ bypassCache: false });
        setIsAuthenticated(true);
      } catch (error) {
        // Not authenticated - withAuthenticator will handle login
        setIsAuthenticated(false);
      } finally {
        setIsCheckingAuth(false);
      }
    };
    
    checkAuthStatus();
  }, [isPublicRoute]);
  
  useEffect(() => {
    // Listen for route changes (for SPA navigation)
    const handleLocationChange = () => {
      const newIsPublic = getIsPublicRoute();
      setIsPublicRoute(newIsPublic);
    };
    
    // Listen for browser navigation events
    window.addEventListener('popstate', handleLocationChange);
    
    return () => {
      window.removeEventListener('popstate', handleLocationChange);
    };
  }, []);
  
  // Show loading spinner while checking authentication
  // This prevents the login form from flashing for authenticated users
  if (isCheckingAuth) {
    return (
      <div className="flex justify-center items-center h-screen">
        <RiseLoader
          color={"#ffffff"}
          loading={true}
          css={{ display: "block", margin: "0 auto" }}
          size={40}
          aria-label="Loading Spinner"
        />
      </div>
    );
  }
  
  // If it's a public route, render the app without authentication
  if (isPublicRoute) {
    return <App />;
  }
  
  // For all other routes, require authentication
  const AuthenticatedApp = withAuthenticator(App, {
    components: { Header: HeaderWithLogo, Footer: Footer },
  });
  
  return <AuthenticatedApp />;
};

export default AppWrapper;
